/* eslint-disable react/prop-types */
import React from 'react';

export const IconInfoPrimary = ({ fill = '#1A6989', size = '19' }) => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 24 24"
		xmlns="http://www.w3.org/2000/svg"
	>
		<g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
			<circle stroke={fill} strokeWidth="2" cx="12" cy="12" r="10" />
			<rect fill={fill} x="11" y="9" width="2" height="9" rx="1" />
			<circle id="Oval-2" fill={fill} cx="12" cy="7" r="1" />
		</g>
	</svg>
);

export const IconError = ({ fill = '#E93259', size = '19' }) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={size}
		height={size}
		viewBox="0 0 19 19"
	>
		<path
			fill={fill}
			fillRule="nonzero"
			d="M9.5 1.638A7.843 7.843 0 0 1 17.362 9.5 7.843 7.843 0 0 1 9.5 17.362 7.843 7.843 0 0 1 1.638 9.5 7.843 7.843 0 0 1 9.5 1.638zM9.5 0C4.259 0 0 4.259 0 9.5S4.259 19 9.5 19 19 14.741 19 9.5 14.741 0 9.5 0zm1 5.13c0-.611-.436-1.13-1-1.13-.54 0-1 .489-1 1.13v5.74c0 .611.436 1.13 1 1.13.54 0 1-.489 1-1.13V5.13zM9.5 13c-.54 0-1 .462-1 1 0 .564.436 1 1 1 .54 0 1-.462 1-1 0-.54-.46-1-1-1z"
		/>
	</svg>
);

export const Exclamation = () => (
	<svg
		width="144px"
		height="144px"
		viewBox="0 0 144 144"
		version="1.1"
		xmlns="http://www.w3.org/2000/svg"
	>
		<g
			id="|-Misc-Pages"
			stroke="none"
			strokeWidth="1"
			fill="none"
			fillRule="evenodd"
		>
			<g
				id="404"
				transform="translate(-650.000000, -292.000000)"
				fill="#E8301B"
			>
				<g id="Container" transform="translate(360.000000, 292.000000)">
					<g id="Icons/Error-XXL" transform="translate(290.000000, 0.000000)">
						<g id="Group">
							<path
								d="M72,144 C32.235498,144 0,111.764502 0,72 C0,32.235498 32.235498,0 72,0 C111.764502,0 144,32.235498 144,72 C144,111.764502 111.764502,144 72,144 Z M72,140 C109.555363,140 140,109.555363 140,72 C140,34.444637 109.555363,4 72,4 C34.444637,4 4,34.444637 4,72 C4,109.555363 34.444637,140 72,140 Z M70,39 L74,39 L74,93 L70,93 L70,39 Z M74,101 L74,105 L70,105 L70,101 L74,101 Z"
								id="Oval"
								fillRule="nonzero"
							/>
						</g>
					</g>
				</g>
			</g>
		</g>
	</svg>
);
